import { Controller } from '@hotwired/stimulus'

import { AniX } from 'anix'

import {
    addClass,
    target
} from '../utils'

AniX.useTranstionEvent = true;

export default class extends Controller {

    static targets = [
        'overlay',
        'notificaciones',
        'cfe'
    ]

    static values = {
    }

    overlay = () => target(this, 'overlay')

    notificaciones = () => target(this, 'notificaciones')

    cfe = () => target(this, 'cfe')

    initialize = () => {
    }

    connect = () => {

        this.open()
    }

    disconnect = () => {

        this.close()
    }

    open = () => {

        AniX.fromTo(this.notificaciones(), 2, {
            width: '0',
            ease: AniX.ease.easeInOutCirc
        }, {
            width: '100%',
            ease: AniX.ease.easeInOutCirc
        })

        AniX.fromTo(this.cfe(),2, {
            width: '0',
            ease: AniX.ease.easeInOutCirc
        }, {
            width: '100%',
            ease: AniX.ease.easeInOutCirc,
            onComplete: this.close
        })
    }

    close = () => {

        addClass(this.overlay(), 'is-hidden')
    }
}
